import {
    ModelDataChangeCompanyFilter, ModelDataChangeFilterRegistry, ModelDataChangeResponsibilityFilter
} from "@mcleod/components";
import { ModelDataChangeFilterInitializer } from "@mcleod/common";

export class PortalModelDataChangeFilterInitializer extends ModelDataChangeFilterInitializer {
    public initialize() {
        super.initialize();
        ModelDataChangeFilterRegistry.get().register(
            new ModelDataChangeCompanyFilter(),
            new ModelDataChangeResponsibilityFilter()
        );
    }
}
